var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7176 8.32532H44.8843C45.7021 8.32532 46.4863 8.65017 47.0646 9.2284C47.6428 9.80664 47.9676 10.5909 47.9676 11.4087V19.8662C47.9676 31.9961 38.7176 42.2266 29.4676 42.2266C20.2176 42.2266 10.9677 31.9961 10.9677 19.8662V11.4087C10.9677 10.5909 11.2925 9.80664 11.8707 9.2284C12.449 8.65017 13.2332 8.32532 14.051 8.32532H20.2177",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5135 42.2419C14.0506 60.742 35.6339 73.0753 47.9673 60.742",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3241 57.6243C59.5813 57.6243 63.0324 54.1732 63.0324 49.916C63.0324 45.6588 59.5813 42.2076 55.3241 42.2076C51.0669 42.2076 47.6157 45.6588 47.6157 49.916C47.6157 54.1732 51.0669 57.6243 55.3241 57.6243Z",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0949 49.916C56.0949 49.7115 56.0137 49.5155 55.8692 49.3709C55.7246 49.2264 55.5285 49.1451 55.3241 49.1451",
    stroke: "#004171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5532 49.9163C54.5532 50.1207 54.6344 50.3168 54.779 50.4613C54.9236 50.6059 55.1196 50.6871 55.3241 50.6871C55.5285 50.6871 55.7246 50.6059 55.8691 50.4613C56.0137 50.3168 56.0949 50.1207 56.0949 49.9163",
    stroke: "#004171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3241 49.1451C55.1196 49.1451 54.9236 49.2264 54.779 49.3709C54.6344 49.5155 54.5532 49.7115 54.5532 49.916",
    stroke: "#004171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountDoctor);
export default __webpack_public_path__ + "static/media/count_doctor.ba866e4f6b3a50ca3e5167e52a975d12.svg";
export { ForwardRef as ReactComponent };